import { atom } from 'jotai';

import type { DesktopDisplayMode } from '../types';

export const displayModeAtom = atom<DesktopDisplayMode | null>(null);
